import React, { useState, useEffect } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Checkbox,
	TextField,
	TableContainer,
	Paper,
	withStyles,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Button from "../../components/Button";

export const days = {
	ru: [
		"Понедельник",
		"Вторник",
		"Среда",
		"Четверг",
		"Пятница",
		"Суббота",
		"Воскресенье",
	],
	uk: [
		"Понеділок",
		"Вівторок",
		"Середа",
		"Четвер",
		"Пʼятниця",
		"Субота",
		"Неділя",
	],
};

const StyledTableContainer = withStyles({
	root: {
		overflowX: "auto",
	},
})(TableContainer);

const StyledTable = withStyles({
	root: {
		minWidth: 800, // минимальная ширина всей таблицы
	},
})(Table);

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: theme.palette.grey[200],
		fontWeight: "bold",
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTextField = withStyles({
	root: {
		width: "90px",
		"& input": {
			textAlign: "center",
		},
	},
})(TextField);

export const WorkingHoursTable = ({ initialData, onSave }) => {
	const [workingHours, setWorkingHours] = useState([]);

	const { i18n, t } = useTranslation();
	const lang = i18n.language || "ru";

	const handleChange = (index, field, value) => {
		const updated = [...workingHours];
		updated[index][field] = value;
		setWorkingHours(updated);
	};

	const handleDayOffChange = (index, checked) => {
		const updated = [...workingHours];
		updated[index].isDayOff = checked;
		if (checked) {
			updated[index].begin = "00:00";
			updated[index].deliveryEnd = "00:00";
			updated[index].end = "00:00";
		}
		setWorkingHours(updated);
	};

	const handleSave = () => {
		if (onSave) {
			const dataToSave = workingHours.map(({ isDayOff, ...rest }) => rest);
			onSave(dataToSave);
		}
	};

	useEffect(() => {
		if (!initialData) {
			// дефолтные часы
			setWorkingHours(
				days[lang].map(() => ({
					begin: "09:00",
					deliveryEnd: "21:00",
					end: "22:00",
					isDayOff: false,
				}))
			);
			return;
		}

		let preparedData;

		if (initialData.length === 1) {
			// если только один элемент, применяем его ко всем дням
			preparedData = days[lang].map(() => ({ ...initialData[0] }));
		} else {
			preparedData = [...initialData];
		}

		// проставляем dayOff на основе begin/end
		preparedData = preparedData.map((item) => {
			if (item.begin === "00:00" && item.deliveryEnd === "00:00") {
				return { ...item, isDayOff: true };
			}
			return { isDayOff: false, ...item };
		});

		setWorkingHours(preparedData);
	}, [initialData, lang]);

	return (
		<Paper style={{ padding: 20 }}>
			<StyledTableContainer>
				<StyledTable>
					<TableHead>
						<TableRow>
							<StyledTableCell>{t("workTime.day")}</StyledTableCell>
							<StyledTableCell>{t("workTime.start")}</StyledTableCell>
							<StyledTableCell>{t("workTime.endDelivery")}</StyledTableCell>
							<StyledTableCell>{t("workTime.endPickup")}</StyledTableCell>
							<StyledTableCell>{t("workTime.dayOff")}</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{workingHours.map((day, index) => (
							<TableRow key={index}>
								<StyledTableCell>{days[lang][index]}</StyledTableCell>
								<StyledTableCell>
									<StyledTextField
										type="time"
										value={day.begin}
										onChange={(e) =>
											handleChange(index, "begin", e.target.value)
										}
										disabled={day.isDayOff}
									/>
								</StyledTableCell>
								<StyledTableCell>
									<StyledTextField
										type="time"
										value={day.deliveryEnd}
										onChange={(e) =>
											handleChange(index, "deliveryEnd", e.target.value)
										}
										disabled={day.isDayOff}
									/>
								</StyledTableCell>
								<StyledTableCell>
									<StyledTextField
										type="time"
										value={day.end}
										onChange={(e) => handleChange(index, "end", e.target.value)}
										disabled={day.isDayOff}
									/>
								</StyledTableCell>
								<StyledTableCell>
									<Checkbox
										checked={day.isDayOff}
										onChange={(e) =>
											handleDayOffChange(index, e.target.checked)
										}
										color="primary"
									/>
								</StyledTableCell>
							</TableRow>
						))}
					</TableBody>
				</StyledTable>
			</StyledTableContainer>
			<Button
				text={t("buttons.save")}
				handleClick={handleSave}
				// className={classes.saveButton}
			/>
		</Paper>
	);
};
